import TrashIcon from '@mui/icons-material/DeleteOutline'
import ArchiveIcon from '@mui/icons-material/ArchiveOutlined'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';

const GoogleUserSettings = ({ show }) => {
  if (show) return (
    <div className='flex flex-col gap-[20px]'>
      <Settings />
      <Archive />
      <ResponsibilityNote />
    </div>
  )
}

const Settings = () => (
  <div className='fields user-settings'>
    <div className="field mt-5">
      <SettingsOutlinedIcon className="icon" />
      <span className="label">Settings</span>
    </div>
  </div>
)

const Archive = () => (
  <div className='fields user-settings flex flex-col gap-[3px]'>

    <div className="field">
      <ArchiveIcon className="icon" />
      <span className="label">Archive all</span>
    </div>

    <div className="field">
      <TrashIcon className="icon" />
      <span className="label">Remove</span>
    </div>

    <div className="field">
      <TrashIcon className="icon" />
      <span className="label">Remove all</span>
    </div>
  </div>
)

const ResponsibilityNote = () => (
  <div className="m-[10px]">
    <div className="note">The pass provider or merchant is responsible for the info on this pass and may send you notifications. Contact them with any questions.</div>
  </div>
)

export default GoogleUserSettings